import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { GoodsListResp } from 'domain/payload/response/goods/GoodsListResp';
import { GoodsDetailResp } from 'domain/payload/response/goods/GoodsDetailResp';
import { GoodsCreateReq } from 'domain/payload/request/goods/GoodsCreateReq';
import { GoodsUpdateReq } from 'domain/payload/request/goods/GoodsUpdateReq';

const GoodsService = () => {
  const goodsList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<GoodsListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/goods/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const goodsDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<GoodsDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/goods/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const goodsExportToCsv = async (token: string): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/report-engine/download?reportCode=GOODS_CSV_EXPORT&extension=csv`, {}, { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const goodsCreate = async (
    token: string,
    request: GoodsCreateReq
  ): Promise<BaseResponse<GoodsDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/goods/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const goodsUpdate = async (
    token: string,
    request: GoodsUpdateReq
  ): Promise<BaseResponse<GoodsDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/goods/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const goodsDelete = async (
    token: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/goods/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { goodsList, goodsDetail, goodsExportToCsv, goodsCreate, goodsUpdate, goodsDelete };
};

export default GoodsService;